import styled from 'styled-components';
import { theme } from 'assets/styles/theme';
import { DeviceDown } from 'assets/styles/breakpoints';

const Field = styled.div`
  position: relative;
  min-width: 148px;
  max-width: 220px;

  @media ${DeviceDown.sm} {
    min-width: 0;
    max-width: 100%;
    width: 100%;
  }

  &::after {
    content: '';
    position: absolute;
    right: 14px;
    top: 16px;
    width: 8px;
    height: 8px;
    border: solid 2px ${theme.text};
    border-width: 0 0 2px 2px;
    pointer-events: none;
    transform: rotate(-45deg);
  }

  .enrollment-status-select {
    width: 100%;
    height: 40px;
    padding: 8px 36px 8px 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    color: ${theme.text};
    cursor: pointer;
    appearance: none;
    background-color: ${theme.bodyBg};

    &:focus {
      border-color: ${theme.primary};
      outline: 0;
      box-shadow: 0 0 0 3px rgba(86, 183, 247, 0.25);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.65;
    }

    option:disabled {
      color: ${theme.gray};
    }
  }

  &.is-pending .enrollment-status-select {
    border-color: ${theme.primary};
    background-color: #f7fcff;
  }

  .pending-label {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    color: ${theme.secondary};
  }
`;

export default Field;
